import React, { useState } from 'react';
import { TouchableInputProps } from '..';
import { BASE_URL } from '../../../../config';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { HOMEPAGE_VIDEO_VISIT_MODULE, ACTION_CTA_CLICK } from '../../../../core/analytics/events';
import { isClientSide } from '../../../../core/util/system';
import SearchButton from '../SearchButton';
import StateInput from '../StateInput';
import WhenInput from '../WhenInput';

/**
 * The search form for a video visit.
 */
const VideoForm = ({ touched }: TouchableInputProps) => {
  const [state, setState] = useState('');

  const directoryPageUrl = `${BASE_URL}/${state}/s/${state}-telemedicine`;

  function search() {
    analyticsTrackEvent(HOMEPAGE_VIDEO_VISIT_MODULE, { action: ACTION_CTA_CLICK });
    if (isClientSide()) {
      window.location.href = directoryPageUrl;
    }
  }
  return (
    <>
      <StateInput onChange={setState} touched={touched} />
      <WhenInput collapseOnMobile />
      <SearchButton disabled={state === ''} onSearch={search} />
    </>
  );
};

export default VideoForm;
